import Nullstack from 'nullstack';
export default function IconGitPullRequest({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-git-pull-request",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "6",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("line", {
    x1: "6",
    y1: "8",
    x2: "6",
    y2: "16"
  }), "   ", Nullstack.element("path", {
    d: "M11 6h5a2 2 0 0 1 2 2v8"
  }), "   ", Nullstack.element("polyline", {
    points: "14 9 11 6 14 3"
  }), " ");
}